import { BlfButton } from '../../../models/generated/ziroModels';
import { Component, inject, input } from '@angular/core';
import { ZiroFormConfig, ZiroFormsValidationState } from '../../../../forms/ziro-forms-models';
import { HtmlCheckboxType, ZiroCheckboxConfig } from '../../../../forms/fields/checkbox/ziro-checkbox.component';
import { ZiroFormAbstractDirective } from '../../../../forms/ziro-form-abstract.directive';
import { ZiroFormStateService } from '../../../../forms/ziro-form-state.service';
import { PhoneButtonsService } from '../../shared/phone-buttons.service';
import { Observable } from 'rxjs';
import { ZiroFormsModule } from '../../../../forms/ziro-forms.module';

enum PhoneButtonBLF {
  BLF_EXTENSION = 'tkey;pages.details.phoneSettings.button.blf.extension',
  LABEL = 'tkey;pages.details.phoneSettings.button.blf.label',
  CALL_PICKUP = 'tkey;pages.details.phoneSettings.button.blf.callpickup',
}

@Component({
  selector: 'ziro-phone-buttons-blf',
  templateUrl: './phone-buttons-blf.html',
  styleUrls: ['./phone-buttons-form.scss'],
  imports: [ZiroFormsModule],
})
export class PhoneButtonsBlfComponent extends ZiroFormAbstractDirective<BlfButton> {
  protected _ziroFormStateService: ZiroFormStateService;
  private phoneButtonsService = inject(PhoneButtonsService);

  readonly isPending = input(false);
  private _wasExtensionChanged = false;

  formConfig = {
    fields: {
      destination: {
        label: PhoneButtonBLF.BLF_EXTENSION,
        dataAutomation: 'phone-button-speed-dial-blf-number',
        validation: [
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialExtensionLength(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: {
              content: 'tkey;validators.global.error.maxlength',
              params: {
                maxlength: 50,
              },
            },
          },
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialExtensionPattern(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;validators.global.error.invalid_number.pattern',
          },
        ],
      },
      label: {
        label: PhoneButtonBLF.LABEL,
        dataAutomation: 'phone-button-speed-dial-blf-label',
        validation: [
          {
            validator: (val: string) =>
              this.phoneButtonsService.validLabelLength(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: {
              content: 'tkey;validators.global.error.maxlength',
              params: {
                maxlength: 30,
              },
            },
          },
          {
            validator: (val: string) =>
              this.phoneButtonsService.validSpeedDialLabelPattern(val)
                ? ZiroFormsValidationState.VALID
                : ZiroFormsValidationState.INVALID,
            message: 'tkey;validators.global.error.pattern',
          },
        ],
      },
      callPickup: {
        label: PhoneButtonBLF.CALL_PICKUP,
        dataAutomation: 'phone-button-speed-dial-blf-call-pickup',
        componentConfig: new ZiroCheckboxConfig({ checkboxType: HtmlCheckboxType.CHECKBOX }),
      },
    },
    options: {
      columnClasses: {
        label: 'col-3 text-lg-end',
        input: 'col-9',
      },
    },
  } as ZiroFormConfig;

  submit(): Observable<any> {
    return this.parentSubmit$();
  }

  toFormData = (entity: BlfButton): BlfButton => {
    const newEntity = { ...entity };
    if (entity.dn && !entity.destination) {
      newEntity.destination = newEntity.dn.extension;
      delete newEntity.dn;
    }
    return newEntity;
  };

  toEntity = (formData: BlfButton): BlfButton => {
    const newFormData = { ...formData };
    if (this._wasExtensionChanged) {
      delete newFormData.dn;
    } else if (this.entity.dn) {
      newFormData.dn = { ...this.entity.dn };
      newFormData.destination = '';
    }
    return newFormData;
  };

  handleDestinationChange(): void {
    this._wasExtensionChanged = true;
  }
}
